import axios from 'axios';

const backendUri = 'https://neoe2e.neophyte.live/fm-api/';

export const createCamera = async (data, signal) => {
  try {
    console.log('Creating camera with data:', data);
    const response = await axios.post(`${backendUri}camera/create`, data, {
      signal,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    console.log('Create response:', response);

    // Ensure we return the correct structure
    if (response.data && response.data.base64Image) {
      return {
        base64Image: response.data.base64Image,
        camera_id: response.data._id,
        status: response.status
      };
    } else if (response.data && response.data._id) {
      return {
        camera_id: response.data._id,
        status: response.status,
        message: 'Camera created but no image available'
      };
    } else {
      console.error('Unexpected response format:', response.data);
      throw new Error('Invalid response format from server');
    }
  } catch (error) {
    console.error('Create camera error:', error.response || error);
    if (error.name === 'AbortError') {
      throw error;
    }
    if (error.response) {
      const errorMessage = error.response.data.message || error.response.data.error || error.response.statusText || 'Server error occurred';
      throw new Error(errorMessage);
    }
    throw new Error(error.message || 'Unknown error occurred');
  }
};

export const createZones = async (data) => {
  try {
    console.log('Creating zones with data:', data);
    const response = await axios.post(`${backendUri}zone/create`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    console.log('Create zones response:', response);

    // Ensure we return the correct structure
    if (response.data) {
      return response.data;
    } else {
      console.error('Unexpected response format:', response);
      throw new Error('Invalid response format from server');
    }
  } catch (error) {
    console.error('Create zones error:', error.response || error);
    if (error.response) {
      const errorMessage = error.response.data.message || error.response.data.error || error.response.statusText || 'Server error occurred';
      throw new Error(errorMessage);
    }
    throw new Error(error.message || 'Unknown error occurred');
  }
};

export const getCameras = async () => {
  try {
    console.log('Fetching cameras...');
    const response = await axios.get(`https://neoe2e.neophyte.live/fm-api/camera/getAll`);
    console.log('Get cameras response:', response);

    // Ensure we return the correct structure
    if (response.data && Array.isArray(response.data)) {
      return { cameras: response.data };
    } else if (response.data && Array.isArray(response.data.cameras)) {
      return response.data;
    } else {
      console.error('Unexpected response format:', response.data);
      return { cameras: [] };
    }
  } catch (error) {
    console.error('Error fetching cameras:', error.response || error);
    throw new Error(error.response?.data?.message || error.response?.data?.error || error.message || 'Error fetching cameras');
  }
};

export const getAllCameras = async () => {
  try {
    console.log('Fetching all cameras...');
    const response = await axios.get(`https://neoe2e.neophyte.live/fm-api/camera/getAll`);
    console.log('Get all cameras response:', response);

    // Ensure we return the correct structure
    if (response.data && Array.isArray(response.data)) {
      return { cameras: response.data };
    } else if (response.data && Array.isArray(response.data.cameras)) {
      return response.data;
    } else {
      console.error('Unexpected response format:', response.data);
      return { cameras: [] };
    }
  } catch (error) {
    console.error('Error fetching all cameras:', error.response || error);
    throw new Error(error.response?.data?.message || error.response?.data?.error || error.message || 'Error fetching all cameras');
  }
};

export const deleteCamera = async (cameraId) => {
  try {
    console.log('Deleting camera with ID:', cameraId);
    const response = await axios.delete(`${backendUri}camera/delete/${cameraId}`);
    console.log('Delete response:', response);

    // Ensure we return the correct structure
    if (response.data) {
      return response.data;
    } else {
      console.error('Unexpected response format:', response);
      throw new Error('Invalid response format from server');
    }
  } catch (error) {
    console.error('Delete camera error:', error.response || error);
    throw new Error(error.response?.data?.message || error.response?.data?.error || error.message || 'Error deleting camera');
  }
};
